<template>
  <div class="search-image">
    <a-alert
      style="padding: 2px 10px; margin-bottom: 6px"
      message="温馨提示: 【上传图片】按钮支持多张图片同时搜索,切记选择多张图片时请按住【ctrl】键"
      type="error"
    />
    <div class="top">
      <Header
        ref="refHeader"
        :params="currentItem"
        @changeSort="changeSort"
        @searchGoods="searchGoods"
        :currentPlatformType="currentPlatformType"
        :platformList="platformList"
      >
        <a-space>
          <SelectedAll
            :currentItem="currentItem"
            :currentPlatformType="currentPlatformType"
            @resetIsCheckAll="resetIsCheckAll"
          ></SelectedAll>
          <a-button type="primary" danger @click="batchAddPreview">批量铺货预览 ({{ getSelectedRowsNum() }})</a-button>
          <CreateGoodsTemplateModal ref="createGoodsTemplateModal" :hideOpenDouyinButton="true" />
        </a-space>
      </Header>
    </div>
    <PlatformTabs
      :loading="loading"
      :activeKey="currentPlatformType"
      :platformList="platformList"
      :getGoodsList="getGoodsListByType"
      @change-activeKey="changeSearchImagePlatform"
    />
    <a-spin style="min-height: 150px" :spinning="loading" tip="正在加载数据中，请耐心等待" size="large">
      <GoodsList
        :list="currentItem.platformInfo[`${currentPlatformType}_info`].list"
        isSearchImage
        :canCommitRepeat="this.$refs.createGoodsTemplateModal?.currentGoodsTemplate?.is_repeat"
        @add-preview="singleAddPreview"
        @click-item="clickItem"
      />
    </a-spin>
    <AuthTaoteModal ref="authTaoteModal" @success="searchGoods" />
  </div>
</template>
<script>
import Header from "./components/header";
import PlatformTabs from "./components/platform_tabs";
import AuthTaoteModal from "@/views/moving_function/components/auth_taote_modal";
import selectGoodsHandler from "@/views/moving_function/views/select_goods/handler";
import CreateGoodsTemplateModal from "@/views/moving_function/components/create_goods_template_modal";
import GoodsList from "@/views/moving_function/views/select_goods/components/goods_list";
import SelectedAll from "./components/selected_all";
import handler from "./handler";
export default {
  components: { Header, AuthTaoteModal, PlatformTabs, CreateGoodsTemplateModal, GoodsList, SelectedAll },
  data() {
    return {
      loading: false,
      platformList: [],
      currentPlatformType: "ali",
      currentItem: {
        value: "searchImage",
        msg: "请先上传一张图片",
        placeholder: "可输入图片链接，点击【搜索】按钮搜索商品",
        platformInfo: {},
        isCheckAll: false,
        params: {
          keyword: "",
          page: 1,
          size: 100,
        },
      },
      getSelectedRows: [],
    };
  },
  computed: {
    getGoodsListByType() {
      return this.currentItem.platformInfo[`${this.currentPlatformType}_info`]?.list;
    },
  },
  methods: {
    //改变排序
    changeSort(e) {
      this.sortType = e;
      this.currentItem.platformInfo[`${this.currentPlatformType}_info`]?.list.sort((res1, res2) => {
        if (this.sortType == "priceUp") {
          return res1.price - res2.price;
        } else {
          return res2.price - res1.price;
        }
      });
    },
    getPlatformList() {
      this.platformList = selectGoodsHandler.GetRouterByPlatform();
      this.platformList.forEach((item) => {
        var key = `${item.value}_info`;
        var info = {
          list: [],
          selectedList: [],
          total: 0,
        };
        this.currentItem.platformInfo[key] = info;
      });
    },
    // 搜索商品
    async searchGoods(currentItem, isReload) {
      if (!this.$refs.refHeader?.imgUrls) return;
      if (currentItem) this.currentItem = currentItem;
      // 找到当前选中的图片以及默认的平台,查询商品
      if (this.currentItem.platformInfo[`${this.currentPlatformType}_info`].list.length && !isReload) return;
      this.loading = true;
      let filter = this.$refs.refHeader?.$refs?.filterOption?.params;
      filter = filter?.length ? filter.join(",") : "";
      await handler.GetGoodsListBySearchImg(this, filter);
      this.loading = false;
    },
    getSelectedRowsNum() {
      var fileList = this.$refs.refHeader?.fileList || [];
      var length = 0;
      var getSelectedRows = [];
      fileList.forEach((item) => {
        for (var key in item.platformInfo) {
          var info = item.platformInfo[key];
          var itemLength = info.selectedList.length;
          getSelectedRows = [...getSelectedRows, ...info.selectedList];
          length += itemLength;
        }
      });
      this.getSelectedRows = getSelectedRows;
      return length || 0;
    },
    // 切换搜图的平台时
    changeSearchImagePlatform(value) {
      this.currentPlatformType = value;
      this.searchGoods();
    },
    // 单个商品铺货预览
    singleAddPreview(item) {
      selectGoodsHandler.SingleAddPreview(this, item);
    },
    // 批量商品铺货预览
    batchAddPreview() {
      selectGoodsHandler.BatchAddPreview(this);
    },
    // 点击商品时触发
    clickItem(item) {
      selectGoodsHandler.ClickItem(
        this.currentItem.platformInfo[`${this.currentPlatformType}_info`].selectedList,
        item
      );
    },
    // 清空已选择的商品
    clearSelectedGoods() {
      this.$refs.refHeader.ClearAllChecked();
    },
    resetIsCheckAll(isCheckAll) {
      this.currentItem.isCheckAll = isCheckAll;
      var typeInfo = this.currentItem.platformInfo[`${this.currentPlatformType}_info`];
      typeInfo.selectedList = [];
      typeInfo.list.forEach((item) => {
        item.selected = isCheckAll;
        if (isCheckAll) typeInfo.selectedList.push(item);
      });
    },
  },
  created() {
    this.getPlatformList();
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
